export const chileTitles = {
  title: '¡Todo listo, ya enviaste a evaluar!',
  description: 'Te notificaremos tan pronto tengamos los resultados',
};

const mexicoTitles = {
  title: '¡Listo! Ya recibimos tus facturas.',
  description: 'Te avisaremos cuando tengamos una respuesta sobre su aprobación.',
};

const countryTitles = {
  Chile: chileTitles,
  Mexico: mexicoTitles,
};

export default countryTitles;
